<template>
  <sidebar title="Biller and Products Settings" :show="showSettingsSidebar" @on-close="close" size="xl">
    <template v-slot:body>
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button"
            role="tab" aria-controls="home" aria-selected="true">Billers</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button"
            role="tab" aria-controls="profile" aria-selected="false">Products</button>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
          <div class="row">
            <div class="col">
              <div class="card-body px-0 pt-0 pb-2">
                <div class="row mt-2 mb-3">
                  <div class="col-8 align-items-center">
                    <div class="row">
                      <div class="col-4">
                        <label>Category:</label>
                        <select class="form-select">
                          <option value="0">All</option>
                          <option>
                            <!-- {{ category.name }} -->Loans
                          </option>
                        </select>
                      </div>
                      <div class="col-6">
                        <label>Filter:</label>
                        <div class="input-group">
                          <span class="input-group-text text-body">
                            <i class="fas fa-search" aria-hidden="true"></i>
                          </span>
                          <input type="text" class="form-control" placeholder="Search Biller/s" />
                        </div>
                      </div>
                      <div class="col d-flex align-self-end">
                        <div class="">
                          <label class="switch">
                            <input type="checkbox" />
                            <span class="slider round"></span>
                          </label> <label>Availability</label>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-responsive p-0">
                  <table class="table main-table">
                    <thead>
                      <tr>
                        <th class="text-center"> <input type="checkbox"></th>
                        <th> Category </th>
                        <th> Code </th>
                        <th> IMG </th>
                        <th> Name </th>
                        <th> Description </th>
                        <th> Availability </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- <tr v-if="isLoading">
            <td colspan="7">
              <div class="text-center">
                <Vue3Lottie
                  :animationData="searchingJSON"
                  class="height-150 py-2"
                />
              </div>
            </td>
          </tr>
          <tr v-if="!isLoading && pageItems.length == 0">
            <td colspan="7">
              <div class="text-center">
                <Vue3Lottie
                  :animationData="noDataJSON"
                  class="height-150 py-2"
                />
                <p class="text-xs font-weight-bold">No Data Found</p>
              </div>
            </td>
          </tr> -->
                      <tr>
                        <td class="text-center"> <input type="checkbox"></td>
                        <td>
                          <!-- {{ category.category }} -->
                          <p class="main-text"> Loans</p>
                        </td>
                        <td>
                          <!-- {{ category.code }} -->
                          ACOMC
                        </td>
                        <td>
                          <img src="/img/masterdealer.png" style="height: 2.5em;" alt="logo" />
                          <!-- <img
                              :src="category.logo"
                              style="width: 40px; margin-right: 20px"
                            /> -->
                        </td>
                        <td>
                          <!-- {{ category.name }} -->
                          ACOM CONSUMER FINANCE CORPORATION
                        </td>
                        <td>
                          <!-- {{ category.description ? category.description : "-" }} -->
                          ACOM Consumer Finance Corporation
                        </td>
                        <td>
                          <label class="switch">
                            <input type="checkbox" />
                            <span class="slider round"></span>
                          </label>
                        </td>
                      </tr>


                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>






        </div>
        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">Products</div>
      </div>
    </template>
  </sidebar>
</template>

<script>
import sidebar from "../../../../../components/sidebar.vue";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  components: {
    sidebar,
  },


  methods: {
    close() {
      this.setShowSettingsSidebar(false);
    },
  },
  computed: {
    ...mapState({
      showSettingsSidebar: (state) =>
        state.retailerController.showSettingsSidebar,
    }),

    ...mapMutations({
      setShowSettingsSidebar: "retailerController/SET_ShowSettingsSidebar",
      selectSubRetailer: "retailerController/SELECT_SubRetailer",
    }),

  },




};
</script>

<style></style>